import './index.scss';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FeedbackModal } from '@components/Modals/FeedbackModal';
import { translate } from '@utils';
import { makeFeedbackData } from '@actions/feedbackActions';
import { Popover } from '@material-ui/core';
import { Button } from '@sharedComponents/DesignSystem/Inputs';
import { EmailIcon } from '@images/icons';
import { MgState, UserEntityInterface } from '@types';
import { supportDataUsersSelector } from '@selectors/feedback';

export const Feedback = () => {
  const dispatch = useDispatch();
  const users = useSelector<MgState, UserEntityInterface[]>(supportDataUsersSelector);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = (event) => {
    dispatch(makeFeedbackData());
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="feedback">
        <Button onClick={handleOpenModal} type="basic-secondary">
          <div className="feedback-content">
            <a className="feedback-link">
              <span className="feedback-link__text">{`${translate('contact_us')}!`}</span>
            </a>
            <EmailIcon />
          </div>
        </Button>
      </div>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        onClose={handleCloseModal}
        open={isOpen}
      >
        <FeedbackModal users={users} onClose={handleCloseModal} />
      </Popover>
    </>
  );
};
